var map = {
	"./arjiv-exports-diamond-trade-show.jpg": 7617,
	"./gem-geneva-international-expo-2025-arjiv-exports.jpeg": 873,
	"./gem-geneva-international-expo-arjiv-exports.jpg": 1660,
	"./hong-kong-jewelry-manufacturers-association-arjiv-exports.jpg": 9920,
	"./hong-kong-trade-development-council-arjiv-exports.jpg": 8661,
	"./hong-kong-trade-development-council-expo-arjiv-exports-2024.jpg": 2249,
	"./jewelry-circular-keystone-arjiv-exports.jpg": 7551,
	"Assets/Image/Shows/arjiv-exports-diamond-trade-show.jpg": 7617,
	"Assets/Image/Shows/gem-geneva-international-expo-2025-arjiv-exports.jpeg": 873,
	"Assets/Image/Shows/gem-geneva-international-expo-arjiv-exports.jpg": 1660,
	"Assets/Image/Shows/hong-kong-jewelry-manufacturers-association-arjiv-exports.jpg": 9920,
	"Assets/Image/Shows/hong-kong-trade-development-council-arjiv-exports.jpg": 8661,
	"Assets/Image/Shows/hong-kong-trade-development-council-expo-arjiv-exports-2024.jpg": 2249,
	"Assets/Image/Shows/jewelry-circular-keystone-arjiv-exports.jpg": 7551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2200;